module.exports = __webpack_public_path__ + "static/media/shipyard.ab98c723.svg";